// extracted by mini-css-extract-plugin
export default {"optionLabel":"optionLabel---UlUoS","totalRecordsLabel":"totalRecordsLabel---d_Yvw"};